/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Export Transcription" |
*
* @param {Transcript_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_title = /** @type {((inputs?: Transcript_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkription exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione della trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт транскрипции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出转录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("転写のエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेखन निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar transcrição")
	return /** @type {LocalizedString} */ ("Export Transcription")
});